<div class="cvx-header-container">
  <div class="cvx-header-menu"></div>

  <div class="cvx-header-application">
    <img src="assets/images/hallmark.png" alt="Logo" />
    <span>{{ pTitle() }}</span>
  </div>

  <div class="cvx-header-profile">
    <div class="cvx-header-profile-info">
      <div class="cvx-header-user-text">
        <span class="cvx-header-user-name">{{ pFullName() }}</span>
        <span class="cvx-header-user-role" *ngIf="pRoleName()">{{ pRoleName() }}</span>
      </div>
      @if (shouldShowImage()) {
        <img [src]="srcImageUser()" alt="User Image" class="user-avatar-img" />
      } @else {
        <div class="user-avatar-initials" [title]="pFullName()">
          {{ getUserInitials() }}
        </div>
      }
    </div>
  </div>
</div>
